interface BrandLinkProps {
    brandName: string;
}

export default function BrandLink({brandName}: BrandLinkProps) {
    const getBrandSite = (brandName: string) => {
        const brandSites: Record<string, string> = {
            'thorvik': 'https://www.thorvik.ru',
            'ombra': 'https://www.ombratools.ru',
            'carbon': 'https://www.carbontools.ru',
            'jonnesway': 'https://www.jonnesway.ru',
            'rotake': 'https://www.rotakepro.ru',
        };
        return brandSites[brandName.toLowerCase()] || 'https://www.pride.ru';
    }

    return (
        <a href={getBrandSite(brandName)} target="_blank" rel="noopener noreferrer">
            О бренде
        </a>
    );
}